import * as React from 'react'

import { EuiFlexGroup } from '@elastic/eui'
import styled from '@emotion/styled'
import shouldForwardProp from '@styled-system/should-forward-prop'

import * as system from 'styled-system'

import { StyledViewProps } from '../Grid/StyledView'

export type IFlexGroupProps = StyledViewProps & React.ComponentProps<typeof EuiFlexGroup>

export const StyledFlexGroup = styled(EuiFlexGroup, { shouldForwardProp })<IFlexGroupProps>(
  system.color,
  system.flexbox,
  system.space,
  system.layout,
  system.position,
  system.justifyContent,
  system.alignItems,
  system.borders,
  system.shadow,
  system.background,
)

export const FlexGroup: React.FC<IFlexGroupProps> = (props) => {
  const { children, ...rest } = props
  return <StyledFlexGroup {...rest}>{children}</StyledFlexGroup>
}

FlexGroup.displayName = 'FlexGroup'

export default FlexGroup
